import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUri, filterRequest } from "../../utilities/apiManager";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null
}

export const getInsurance = createAsyncThunk(
  "insurance/getInsurance",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query } = args;
      const filter = filterRequest(args.filter);
      const { data } = await axios.get(
        `${apiUri}/insurance_histories?page=${page}&size=${size}&query=${query}${filter}`,
        {
          headers: {
            'Content-Type': 'application/json',
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
            "Accept-Language": document.documentElement.lang,
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateInsurance = createAsyncThunk(
  "insurance/updateInsurance",
  async (args, thunkApi) => {
    try {
      const { data } = await axios.put(
        `${apiUri}/insurance_histories/${args._id}`,
        args.values,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
            "Accept-Language": document.documentElement.lang,
          }
        }
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const insuranceSlice = createSlice({
  name: "insurance",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getInsurance.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getInsurance.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data;
        state.itemsCount = payload.itemsCount;
        state.pages = payload.pages;
        state.error = null;
      })
      .addCase(getInsurance.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message
      })

      .addCase(updateInsurance.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateInsurance.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        const indexAt = state.data.findIndex(el => el._id === payload.data._id);
        state.data[indexAt] = payload.data;
        state.error = null;
      })
      .addCase(updateInsurance.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export default insuranceSlice.reducer;